(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('approvalApproveAction', {
      controller: Controller,
      templateUrl: 'actions/approval/approve/approve-approval.action.html',
      bindings: {
        type: '@',
        batch: '<',
        then: '&',
        catch: '&'
      }
    });
}());
